export const view05ImageOptions = {
  angle: 'view05',
  staticOptions: {
    HullColour: 1,
    BowSprit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    BathingPlatform: 1,
    TeakOnBathingPlatform: 1,
    Wheel: 1,
    BoomCover: 1,
    CockpitTable: 1,
    Sprayhood: 1
  },
  mattes: [
    {
      option: 'HullColour',
      dependency: 'BathingPlatform'
    },
    {
      option: 'BowSprit',
      dependency: 'HullColour'
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: 'SelfTacker'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    },
    {
      option: 'Wheel',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: null
    },
    {
      option: 'CockpitTable',
      dependency: 'Wheel'
    },
    {
      option: 'Sprayhood',
      dependency: 'BoomCover'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X43MK2/views/view05.js